import { render, staticRenderFns } from "./readonly.vue?vue&type=template&id=e2c5ca98"
import script from "./readonly.vue?vue&type=script&lang=js"
export * from "./readonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports